function tocFunctionality() {

// Table of contents functionality
  const toc = document.querySelector('.toc');
  if (toc) {
//  Toggle functionality
    const tocToggle = document.querySelector('.toc__toggle');
    tocToggle.addEventListener('click', function() {
      this.classList.toggle('toc__toggle--active');
      toc.classList.toggle('toc--active');
    });

    // Clicking on toc link makes it active
    const tocLink = toc.querySelectorAll('.toc__link');
    tocLink.forEach(element => {
      element.addEventListener('click', function() {
        // Remove active class from all links
        tocLink.forEach(link => {
          link.classList.remove('toc__link--active');
        });
        // Add active class to clicked link
        element.classList.toggle('toc__link--active');
        tocToggle.classList.toggle('toc__toggle--active');
        toc.classList.toggle('toc--active');
        
      });
    });
    
    //Clicking on toc link makes it go to correct scroll depth
    tocLink.forEach(ele =>{
      ele.addEventListener('click', function (event) {
        event.preventDefault();

        // Retrieving the toc link id
        let tocChosen = ele.getAttribute("href").split('#')[1];;
        let hrefElement = document.getElementById(tocChosen);

        let bodyRect = document.body.getBoundingClientRect().top;
        let elementRect = hrefElement.getBoundingClientRect().top;
        let elementPosition = elementRect - bodyRect;

        //Checks if the device used is mobile. 
        let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
        let offset = isMobile ? -434:-28;

        let offsetPosition = elementPosition + offset;

        //hrefElement.scrollIntoView(true);
        window.scrollTo({
          top: offsetPosition
      
        });
      })
    }) 


  }
}

export default tocFunctionality;
